import { cartFulfillmentMethodStyles } from "@insite/content-library/Widgets/Cart/CartFulfillmentMethodSelector";
import WhitecapColors from "@WhiteCap/Utils/WhiteCapColor";
import { css } from "styled-components";

/*

**** EC-421 - PLP ****

*** Start: Refactored dynamic CSS from CMS to code for consistent behavior across environments. */

cartFulfillmentMethodStyles.pickUpLocation = {
    wrapper: {
        css: css`
            margin-top: 10px;
            background-color: ${WhitecapColors.lightGray};
            border-top: 1px solid ${WhitecapColors.gray3};
            margin-bottom: 20px;
            padding: 20px;
        `,
    },
    headerText: {
        weight: 500,
        css: css`
            font-size: 12px;
        `,
    },

    changeLink: {
        css: css`
            margin-left: 15px;
            font-size: 12px;
        `,
    },
    warehouseAddress: {
        // EC-27 : Sub Task - 553 Cart Page 
        // Start: Refactored dynamic CSS from CMS to code for consistent behavior across environments.
        wrapper:{
            css: css`
                margin-top: 8px;
            `
        },
        // EC-27 : Sub Task - 553 Cart Page 
        // End: Refactored dynamic CSS from CMS to code for consistent behavior across environments.
        address: {
            wrapper: {
                css: css`
                    font-size: 14px;
                `,
            },
        },
        
        nameText: {
            as: "p",
            css: css`
                // EC-27 : Sub Task - 553 Cart Page 
                // Refactored dynamic CSS from CMS to code for consistent behaivor
                    font-size: 15px;
        
                // End: Refactored dynamic CSS from CMS to code for consistent behavior across environments.
            `,
        },
    },
};


/* *** End: Dynamic CSS refactoring complete. Apply future updates here instead of the CMS.*/
